import type { AlertDialogProps } from "@/theme"
import React from "react"

import type { HelpContentProps } from "@/components/HelpContent"
import { getHelpContent } from "@/components/HelpContent"
import {
  AlertDialog,
  AlertDialogBodyText,
  AlertDialogScrollView,
  CloseButton,
  HelpIconButton,
} from "@/theme"
import i18n from "@/translations/i18n"

import type { SetOptional } from "type-fest"

export function HelpDialog({
  bodyElement,
  children,
  onClose,
  titleElement,
  ...rest
}: SetOptional<AlertDialogProps, "titleElement"> & {
  bodyElement?: React.JSX.Element | string
}) {
  return (
    <AlertDialog
      IconComponent={"Info"}
      actionElement={<CloseButton onPress={onClose} />}
      id={"helpContent"}
      titleElement={titleElement ?? i18n.t("help")}
      onClose={onClose}
      {...rest}
    >
      <AlertDialogScrollView>
        {typeof bodyElement === "string" ? (
          <AlertDialogBodyText>{bodyElement}</AlertDialogBodyText>
        ) : (
          bodyElement
        )}
        {children}
      </AlertDialogScrollView>
    </AlertDialog>
  )
}

export function Help(props: HelpContentProps) {
  const [isOpen, setIsOpen] = React.useState(false)
  const content = getHelpContent(props)
  if (content == null) {
    return null
  }
  return (
    <React.Fragment>
      <HelpIconButton onPress={() => setIsOpen(true)} />
      <HelpDialog
        {...content}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </React.Fragment>
  )
}
